import {PostProcessor} from '../../types/postprocessor/PostProcessor';
import {request} from '../request';

export async function getApplicationPostProcessors({
  projectId,
  applicationId,
  spaPostProcessorId,
}: {
  projectId: string;
  applicationId: string;
  spaPostProcessorId?: string;
}) {
  let url = `/postprocessor/get/application/${projectId}?applicationId=${applicationId}`;
  if (spaPostProcessorId) {
    url += `&spaPostProcessorId=${spaPostProcessorId}`;
  }
  return request<Array<PostProcessor>>({
    method: 'get',
    url: url,
  });
}
